@use '../../scss/utility/functions' as utility;

:host {
  --variant-color: var(--wb-grey-20);
  --icon-color: var(--wb-white);
  --shape-1-fill: var(--wb-white);
  --border-color: var(--wb-grey-20);
  --background-color: var(--wb-grey-15);

  pointer-events: all;
  // transition: set from notification.tsx
  transform-origin: bottom;

  opacity: 0;
  // margin-block-end: set from notification.tsx
  transform: scale3d(0.95, 0.95, 0.95);

  background-color: var(--background-color);
  color: var(--wb-white);
  border-radius: var(--wb-radius-m);
  box-sizing: border-box;

  border: utility.wb-pixel-to-rem(2px) solid var(--variant-color); // see notification-host.scss for sticky notification border styles
  display: flex;
  flex-direction: column;
  width: 100%;
}

.icon {
  color: var(--icon-color);
}

.icon,
.wb-badge {
  position: absolute;
  inset-block-start: utility.wb-pixel-to-rem(16px);
  inset-inline-start: utility.wb-pixel-to-rem(16px);
  --size: 24px;
}

.wb-icon {
  fill: var(--shape-1-fill);
}

.dismiss-button {
  position: absolute;
  inset-block-start: utility.wb-pixel-to-rem(10px);
  inset-inline-end: utility.wb-pixel-to-rem(10px);
}

.content {
  padding: utility.wb-pixel-to-rem(16px);
}

:host(:not(.has-footer)) .footer {
  display: none;
}

.footer {
  border-block-start: utility.wb-pixel-to-rem(1px) solid var(--border-color);
  padding: utility.wb-pixel-to-rem(8px);
}

:host([variant]) {
  border-color: var(--variant-color);
  --icon-color: var(--variant-color);
}

:host([variant='error']) {
  --variant-color: var(--wb-red-45);
  --shape-1-fill: var(--wb-red-90);
}

:host([variant='highlight']) {
  --variant-color: var(--wb-blue-45);
  --shape-1-fill: var(--wb-blue-90);
}

:host([variant='warning']) {
  --variant-color: var(--wb-yellow-45);
  --shape-1-fill: var(--wb-yellow-10);
}

:host([variant='success']) {
  --variant-color: var(--wb-green-45);
  --shape-1-fill: var(--wb-green-90);
}

:host([icon]) .content,
:host([variant='success']) .content,
:host([variant='warning']) .content,
:host([variant='error']) .content {
  padding-inline-start: utility.wb-pixel-to-rem(56px);
}

:host([lifetime]) {
  .wb-round-button {
    --background-color: var(--wb-grey-90);
  }
}

:host(:not([hide-dismiss-button])) .content {
  padding-inline-end: utility.wb-pixel-to-rem(56px);
}

:host(.is-visible) {
  opacity: 1;
  transform: scale3d(1, 1, 1);
}

:host([theme='dark']) {
  --icon-color: currentColor;
  --border-color: var(--wb-grey-85);
  --background-color: var(--wb-grey-90);

  color: var(--wb-grey-20);
  border-color: var(--border-color);
}
